import type { Locale } from "@/lib/i18n";
import { pl, type CFilesToDownloadTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cFilesToDownloadTranslations: Record<Locale, CFilesToDownloadTranslations> = {
  pl,
  en,
  de,
};

export type { CFilesToDownloadTranslations };
